/**
 * Modal functionality
 *
 * @description This file includes the required functionality for modals
 *
 * @return void
 * @access public
 *
 */

import {body, addEventListenerIfElExists, getClosest, viewportWidth} from './helpers';

/**
 * Import Modal Effects that are responsible to handle modal functionality
 */
import './modal-effects';

export const modal = () => {
	const modalClose = document.querySelectorAll( '.js-modal-close' );
	const mdOverlay  = document.querySelectorAll( '.md-overlay' );


	/**
	 * Modal Close click functionality
	 *
	 * @return void
	 * @since  1.0.0
	 * @access public
	 */
	modalClose.forEach( function ( element, index ) {
		element.addEventListener( 'click', function ( event ) {
			body.classList.remove( 'is-modal-open' );

			if ( viewportWidth < 768 ) {
				body.classList.remove( 'is-hidden' );
			}
		} );
	} );

	/**
	 * MD Overlay click functionality
	 *
	 * @return void
	 * @since  1.0.0
	 * @access public
	 */
	mdOverlay.forEach( function ( element, index ) {
		element.addEventListener( 'click', function ( event ) {
			event.preventDefault();
			body.classList.remove( 'is-modal-open' );

			if ( viewportWidth < 768 ) {
				body.classList.remove( 'is-hidden' );
			}
		} );
	} );

}
